import { Component, Input, OnInit } from '@angular/core';
import { ApprovalDetailService } from '../../../services/approvalDetail/approval-details.service';
import { GetTimelines } from '../../../models/approval-details/get-approval-details.model';
import { SharedConst } from 'src/app/core/constants/shared.constant';

@Component({
  selector: 'app-sme-timeline',
  templateUrl: './sme-timeline.component.html',
  styleUrls: ['./sme-timeline.component.scss'],
    standalone: false
})
export class SmeTimelineComponent implements OnInit {
  @Input() requestIssueId: number = 0;
  @Input() requestLineId: number = 0;
  @Input() currParentRowIndex: number = 0;
  dateFormatWithTime: string = SharedConst.dateFormatWithTime;

  timelineDetails: GetTimelines[] = [];

  constructor(private _approvalDetailService: ApprovalDetailService) {}

  ngOnInit(): void {
    this.getTimelineDetails();
  }

  // to get details of timeline
  getTimelineDetails(): void {
    this._approvalDetailService
      .getTimelinesByRequestLineId(this.requestIssueId, this.requestLineId)
      .subscribe((data: any) => {
        if (data) {
          data.map((ele: any) => {
            ele.createdDate = new Date(ele.createdDate + 'Z');
            this.timelineDetails = data;
          });
        }
      });
  }
}
